
/*
 *   File : line.js
 *   Author URI : https://evoqueinnovativelab.com
 *   Description : line.js
 *   Integrations : 
 *   Version : v1.0
 */

/*import package*/
import React, { Component } from 'react';
import Chart from "react-apexcharts";

class LineChart extends Component {
	constructor(props) {
		super(props);
		this.state = {
			series: [{
				name: '',
				type: 'area',
				data: this.props.data
			}],
			options: {
				// chart: {
				//   height: 350,
				//   type: 'area',
				// },
				stroke: {
					width: [2],
					curve: 'straight'
				},
				xaxis: {
					categories: this.props.label,
					allowDecimals: false,
					axisBorder: {
						show: false,
					},
					axisTicks: {
						show: false,
					},
					lines: {
						show: false
					},
					labels: {
						style: {
							colors: ['#5A596B'],
							fontSize: '10px',
							fontFamily: 'Poppins',
							fontWeight: 400,
							cssClass: 'apexcharts-xaxis-label',
						},
					},
				},
				yaxis: {
					show: true,
					allowDecimals: false,
					lines: {
						show: false
					},
					labels: {
						rotate: -90,
						show: true,
						formatter: (idx) => { return Math.abs(idx) > 99999 ? "₹" + Math.sign(idx) * ((Math.abs(idx) / 100000).toFixed(1)) + 'L' : Math.abs(idx) > 999 ? "₹" + Math.sign(idx) * ((Math.abs(idx) / 1000).toFixed(1)) + 'k' : Math.sign(idx) * Math.abs(idx) },
						style: {
							colors: ['#5A596B'],
							fontSize: '10px',
							fontFamily: 'Poppins',
							fontWeight: 400,
							cssClass: 'apexcharts-yaxis-label',

						},
					},
				},
				grid: {
					show: true,
					borderColor: '#6D6D6D',
					strokeDashArray: 2,
					position: 'back',
				},
				fill: {
					type: 'gradient',
					gradient: {
						shadeIntensity: 1,
						opacityFrom: 0.1,
						opacityTo: 0.9,
						stops: [0, 90, 100]
					},
					colors: this.props.colors,
				},
				colors: this.props.colors,
				markers: {
					size: 0,

				},
				dataLabels: {
					enabled: false,
				},
				tooltip: {
					enabled: true,
					intersect: false,
					followCursor: true,
					y: {
						formatter: function (y) {
							if (typeof y !== "undefined") {
								return props.users ? y.toFixed(0) : "₹" + y.toFixed(0);
							}
							return y;
						}
					},
					shared: true
				},
			},
		};
	}


	render() {

		return (
			<Chart
				options={this.state.options}
				series={this.state.series}
				type="area"
				height={350}

			/>
		);
	}
}


export default LineChart;
